// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3FNVi","colMaxWidth":"Table_colMaxWidth__35ENu"};